import React, { Component } from "react";
export default function Bulb(props) {
	return (
<svg height={props.height} width={props.width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
	<title>{props.title}</title>
	<g fill={props.fill} stroke={props.stroke} strokeWidth={props.strokeWidth}>
		<path d="M2 42h44L24 4 2 42zm24-6h-4v-4h4v4zm0-8h-4v-8h4v8z"/>
	</g>
</svg>
	)}


// WEBPACK FOOTER //
// ./src/assets/img/warning.jsx